"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InlinePreviewsFull_1 = require("./components/InlinePreviewsFull");
var React = require("react");
var isInlinePreviewsOptionDirty_1 = require("./utils/isInlinePreviewsOptionDirty");
var saveInlinePreviewsOption_1 = require("./actions/saveInlinePreviewsOption");
var discardInlinePreviewsOption_1 = require("./actions/discardInlinePreviewsOption");
var owa_session_store_1 = require("owa-session-store");
var InlinePreviewsOption = {
    key: 'inlinePreviews',
    titleStringKey: 'optionTitle_inlinePreviews',
    searchTermsStringKey: 'optionTitle_inlinePreviews',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InlinePreviewsFull_1.default, null); },
        isDirty: isInlinePreviewsOptionDirty_1.default,
        onSave: saveInlinePreviewsOption_1.default,
        onDiscard: discardInlinePreviewsOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () { return owa_session_store_1.getUserConfiguration().UserOptions.ShowInlinePreviews; },
            onToggle: saveInlinePreviewsOption_1.default,
        },
        order: 6 /* InlinePreview */,
        workloads: 1 /* Mail */,
        customTitle: 'options_inlinePreviews_quick_setting_label',
    },
};
exports.default = InlinePreviewsOption;
//# sourceMappingURL=InlinePreviewsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/InlinePreviewsOption.js
// module id = 5093
// module chunks = 2